import { render, staticRenderFns } from "./detailsAud.vue?vue&type=template&id=c261ffae&scoped=true&"
import script from "./detailsAud.vue?vue&type=script&lang=js&"
export * from "./detailsAud.vue?vue&type=script&lang=js&"
import style0 from "./detailsAud.vue?vue&type=style&index=0&id=c261ffae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c261ffae",
  null
  
)

export default component.exports